import React from 'react';
import cn from 'classnames';

import Correct from 'shared/ui/icons/General/Correct';

import styles from './CheckMark.module.scss';

interface ICheckMarkProps {
    size?: 'md' | 'sm',
}

const CheckMark: React.FC<ICheckMarkProps> = ({size = 'md'}) => (
    <span className={cn(styles.check, 'sm' === size && styles.sm)}>
        <Correct/>
    </span>
);

export default CheckMark;
